import { useQueries } from 'react-query';
import * as R from 'ramda';
import useSdmx from './useSdmx';

export default (
  { method, requestsArgs },
  {
    errorHandler,
    successHandler,
    beforeHook,
    transformerHook,
    isEnabled,
    isForceEnabled,
    isNotCached,
  } = {},
) => {
  const { queryKeyFactory, queryFnFactory, queryParamsFactory } = useSdmx({
    beforeHook,
    transformerHook,
    isEnabled,
    isForceEnabled,
  });
  const params = queryParamsFactory();
  let queryOptions = {};
  if (isNotCached) queryOptions.cacheTime = 0;

  const queriesOptions = R.map(requestArgs => {
    const queryKey = queryKeyFactory({ method, requestArgs });
    return {
      ...params,
      ...queryOptions,
      queryKey,
      queryFn: queryFnFactory({ method, requestArgs }, { queryKey }),
      meta: { queryKey, successHandler, errorHandler },
    };
  }, requestsArgs || []);

  const queries = useQueries(queriesOptions);

  return { isEnabled, queries };
};
